const styles = {
    tooltipTriggerIcon: {
        bg: 'webTheme.backgroundDefault',
        borderRadius: 'full',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxSize: '16px'
    },
    infoCircleIcon: {
        width: '20px',
        height: '20px'
    },
    tooltipTriggerButton: {
        variant: 'unstyled',
        minW: 'auto',
        h: '20px',
        width: '20px',
        lineHeight: '0',
        color: 'black',
        cursor: 'pointer'
    },
    popoverContent: {
        p: 0,
        maxW: '272px',
        boxShadow: 'none',
        overflow: 'hidden'
    },
    drawerBody: {
        pt: 0,
        px: '16px',
        pb: '64px'
    }
}

export default styles
